// Single source of truth for the input form's default values.
//
// Values are stored as STRINGS because the form's text fields bind to strings.
// - ConversionsTab uses this as the form's initial state and as the per-field
//   fallback when a saved value is absent (display defaults — what the user sees).
// - useAppData's submit path wraps the numeric ones in Number(...) as a last-resort
//   coercion guard so a blank field never sends NaN to the API.
//
// Edit a default HERE and every consumer picks it up.
export const INPUT_DEFAULTS = {
  soc_sec_benefit: '', soc_sec_benefit_spouse: '', salary: '',
  cont_return_assum: '0.08', dist_return_assum: '0.07',
  inflation_assum: '0.025', soc_sec_grw_assum: '0.025',
  retire_tax_hl: 1, contribution_status: 'S', distribution_status: 'S',
  life_years: '25', trad_savings: '', roth_savings: '',
  dist_start_age: '65', soc_sec_start_age: '65', soc_sec_start_age_spouse: '65',
  taxable_inc_when_convert: '0', taxable_inc_when_distribute: '0',
  distribution_method: 'R', beneficiary_taxable_income: '0', beneficiary_filing_status: '',
  medicare_coverage: 'BD', tax_payment_source: 'O',
  tax_drag_assum: '0.05', dist_reinvest_pct: '0.75',
};
